/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { ICommonTranslation } from '@modules/internationalization/types';

export const KB = 1024;

export const MB = 1024 * 1024;

export const convertBytesToReadableFormat = (bytes: number, transaltion: ICommonTranslation) => {
    if (bytes >= KB && bytes < MB) {
        return `${parseFloat((bytes / KB).toFixed(2))} ${transaltion.kilobyte}`;
    }
    if (bytes >= MB) {
        return `${parseFloat((bytes / MB).toFixed(2))} ${transaltion.megabyte}`;
    }
    return `${bytes} ${transaltion.byte}`;
};
